import Vue from 'vue'
export default ()=>{
    Vue.directive('noBlankSpace',{
        inserted: function (el) {
            let domInput;
            if(el.classList.contains('el-input')==true){
              domInput=el.childNodes.item(1)
            }else{
              domInput=el
            }
            domInput.addEventListener("keyup",function(e){
              domInput.value=domInput.value.replace(/[, ]/g,'')
            });
          }
    })
}